<template>
    <modal
        class="flex-modal flex-modal--alert"
        :title="alert.title"
        :hide-header-close="true"
    >
        <div class="flex-modal__description">
            {{ alert.description }}
        </div>

        <template v-slot:modal-footer>
            <button class="flex-modal__button flex-modal__button--continue" @click="hideAlert">
                OK
            </button>
        </template>
    </modal>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import { HIDE_ALERT } from '@/store/types/mutation-types';

export default {
    computed: {
        ...mapState({
            alert: state => state.alert,
        }),
    },

    created() {
        this.$keydown('enter', this.hideAlert);
        this.$keydown('escape', this.hideAlert);
    },

    destroyed() {
        this.$keydown();
    },

    methods: {
        ...mapMutations({
            hideAlert: HIDE_ALERT,
        }),
    },
};
</script>
